import { PaginationQuery, PaginationQueryDefaultValues } from "../../pagination/pagination-query"

export interface LLTTFInvitationList {
    id: string,
    cohortName: string,
    organization: string,
    currentEnrollment: string,
    expiryDate: string,
    status: string,
    statusDescription: string,

}

export function LLTTFInvitationListDefaultValues(): LLTTFInvitationList {
  return {
    id: '',
    cohortName: '',
    organization: '',
    currentEnrollment: '',
    expiryDate: '',
    status: '',
    statusDescription: ''
  }
}


export type LLTTFInvitationQuery = PaginationQuery & {
  InvitationSearchKeyword: string,
  OrganizationId: string,
  FacilitatorId: number,
  Status: string,
}

export function LLTTFInvitationQueryDefaultValues(): LLTTFInvitationQuery {
  return {
    InvitationSearchKeyword: '',
    OrganizationId: '',
    FacilitatorId: 0,
    Status: '',
    ...PaginationQueryDefaultValues()
  }
}
